import { Button } from '@material-ui/core';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Image from './Image';
import Image_Cover from './Image_Cover';
import Clock from './Clock';
import ACamera from './ACamera';
import XCamera from './XCamera';
import KCamera from './KCamera';
import Hardware from './Hardware';
import MetDisplay from './MetDisplay';
import { displayCelestialCoords } from '../utils/displayCelestialCoords';
import * as constants from '../utils/constants';
import './SiteDetails.css';

function SiteDetails(props) {
  if (!props.siteData || Object.values(props.siteData).length < 1) {
    return (
      <div className='popup'>
        <div className='popup-inner'>
          <Button onClick={props.closePopup}>⬅ Return</Button>
          <div className='site-common'>
            <h1>{`${props.siteName} (${props.siteCode} - ${props.siteMPCcode})`}</h1>
            <h2>Error: No data from this site.</h2>
          </div>
        </div>
      </div>
    );
  }

  const { siteData, siteName, siteCode, siteMPCcode, siteKey, timezone } = props;
  const { qstat, sitech, nn, met_status, weather, mount, dome, svcstat, obs, acam_C, recent } = siteData;
  const { ra_deg, dec_deg } = sitech;

  const stampImg = constants.SERVER_URL + siteData.stamp;
  const xStampImg = constants.SERVER_URL + siteData.xstamp;
  const coverImg = constants.SERVER_URL + siteData.cover;
  const fisheyeImg = constants.DASH_URL + siteData.fish1;

  return (
    <Container maxWidth='false'>
      <div className='popup'>
        <div className='site-stat'>
          <Button onClick={props.closePopup}>⬅ Return</Button>
          <h1>{`${siteName} (${siteCode} - ${siteMPCcode})`}</h1>
          <h2>{qstat}</h2>
          <h3>{displayCelestialCoords(ra_deg, dec_deg)}</h3>
          <div className='row'>
            <p>{`Night #${nn}`}</p>
            <Clock timezone={timezone} />
          </div>
        </div>
        <Grid container xs={12} spacing={2}>
          <Grid item xs={12} sm={4} style={{ textAlign: 'center' }}>
            <Image_Cover
              style={{ width: '100%' }}
              imgSrc={coverImg}
              alt='map of tiles covered on current/most recent night'
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <MetDisplay
              metString={met_status}
              weather={weather}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Hardware
              mountData={mount}
              sitech={sitech}
              domeData={dome}
              acam_C={acam_C}
              obs={obs}
              qstat={qstat}
              svcstat={svcstat}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <ACamera
              camData={recent.length > 0 ? recent[recent.length-1] : { 'data': null }}
              siteKey={siteKey}
              imgSrc={stampImg}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <XCamera
              camData={siteData.xrecent.length > 0 ? siteData.xrecent[0] : { 'data': null }}
              siteKey={siteKey}
              imgSrc={xStampImg}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <KCamera
              camData={siteData.krecent.length > 0 ? siteData.krecent[0] : { 'data': null }}
              metStat={weather.met_desc}
              siteKey={siteKey}
              imgSrc={fisheyeImg}
            />
          </Grid>
        </Grid>
      </div>
    </Container >
  );
}

export default SiteDetails;
